import "app/static/stylus/alerts_component_advanced_search.styl"
import React from "react"
import { Button, Col, FormLabel, FormGroup, Row } from "react-bootstrap"
import InputField from "components/requiredFields/InputField"
import AttachmentButton from "app/static/frontend/components/Attachments"
import ExplainedToggle from "components/ExplainedToggle"
import { IssueManagementSelect } from "selects/containers/PieSelect"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { alwaysValid } from "shared/imports/validationFunctions"

import * as attachmentActions from "attachment/attachment-action-creators"
import { sendUserActionPost } from "shared/user-actions/user-actions-action-creators"
import { attachmentFormSelectors } from "attachment/attachment-selectors"
import swal from "sweetalert"
const mapStateToProps = attachmentFormSelectors
const mapDispatchToProps = { ...attachmentActions }

export class CreateAttachmentForm extends React.Component {
    constructor(props) {
        super(props)
        this.editProject = this.editProject.bind(this)
        this.editShortDescription = this.inputFieldHelper.bind(this, "short_description")
        this.success = this.success.bind(this)
        this.hide = this.hide.bind(this)
        this.state = {
            projectId: this.props.projectId,
        }
    }

    inputFieldHelper(fieldName, input, isValid) {
        if (isValid[fieldName]) {
            this.props.editAttachment(fieldName, input[fieldName])
        }
    }

    editPubliclyAccessible = (toggleVal) => this.props.editAttachment("is_public", toggleVal)

    editProject(value) {
        this.setState({ projectId: value.id })
    }

    // the AttachmentButton will call this function when it's done to clean up
    success() {
        sendUserActionPost({
            userActionType: DjangIO.app.useractions.types.UserActionType.file_uploaded,
        })
        this.props.onSuccessHide()
        this.props.triggerDataRefresh()
        return swal("Success!", "Your file has been uploaded.", "success")
    }

    hide() {
        this.props.onSuccessHide()
    }

    render() {
        return (
            <div className="wizard-container-advanced-search">
                <div className="wizard-title-container-div">
                    <h1>Upload New File</h1>
                </div>
                <FormGroup className="form-group">
                    <div className="input-field-wrapper">
                        <InputField
                            header="Short Description"
                            initialValue=""
                            placeholder={"Enter a short description for your uploaded file..."}
                            updatingFn={this.editShortDescription}
                            validationFn={alwaysValid}
                            dbName="short_description"
                            inputStyle="form-control"
                        />
                    </div>
                </FormGroup>
                <FormGroup className="form-group">
                    <FormLabel className="control-label">Issue</FormLabel>
                    <IssueManagementSelect
                        className="projectSelect"
                        onChange={this.editProject}
                        value={this.state.projectId}
                        multi={false}
                        clearable={false}
                    />
                </FormGroup>
                <FormGroup className="form-group">
                    <FormLabel className="control-label">External Sharing</FormLabel>
                    <ExplainedToggle
                        active={this.props.is_public} // eslint-disable-line camelcase
                        onChange={this.editPubliclyAccessible}
                        on="On"
                        onExplanation="Anyone with the link (even people outside your organization) can access this File"
                        offExplanation="Only your team can access this File"
                        off="Off"
                        size="lg"
                    />
                </FormGroup>
                <Row>
                    <Col md={6}>
                        <Button className="btn-block" onClick={this.hide} variant="default">
                            Cancel
                        </Button>
                    </Col>
                    <Col md={6}>
                        <AttachmentButton
                            addedFields={{
                                short_description: this.props.shortDescription || "",
                                is_public: this.props.is_public,
                                project_id: this.state.projectId,
                                non_outbox_upload: true,
                            }}
                            multiple={false}
                            callback={this.success}
                            buttonText="Choose File"
                        />
                    </Col>
                </Row>
            </div>
        )
    }
}

CreateAttachmentForm.propTypes = {
    editAttachment: PropTypes.func.isRequired,
    is_public: PropTypes.bool.isRequired,
    onSuccessHide: PropTypes.func.isRequired,
    projectId: PropTypes.number,
    shortDescription: PropTypes.string,
    triggerDataRefresh: PropTypes.func.isRequired,
}

CreateAttachmentForm.defaultProps = {
    projectId: undefined,
    shortDescription: "",
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateAttachmentForm)
